import { create } from 'zustand'
import type { PairingPreset } from '@/features/pairing/lib/steps'

interface PairingDialogState {
  open: boolean
  preset: PairingPreset
  /** Bumped on every open so the flow remounts with fresh state. */
  session: number
  show: (preset?: PairingPreset) => void
  close: () => void
}

/** Global "Pair player" dialog, mounted once in the app layout. */
export const usePairingDialog = create<PairingDialogState>()((set) => ({
  open: false,
  preset: {},
  session: 0,
  show: (preset = {}) => set((s) => ({ open: true, preset, session: s.session + 1 })),
  close: () => set({ open: false }),
}))
